export default function ({app, store, route}) {
	const path = route.path.replace(store.state.locale, '').replace(/\/+/, '/'),
		head = {meta: []}, navs = store.state.navs,
		nav = navs.find(o => (o.key.startsWith(path) || (path.includes(o.key) && o.key.replace(/\/+/, '') !== ''))) || navs[0] || {}
	for (const key in nav.extra) {
		if (key === 'title') {
			if(store.state.locale=='en'){
				head[key] = nav.extra[key].en
			}else{
				head[key] = nav.extra[key].zh
			}

		} else {
			head.meta.push({
				hid: key,
				name: key,
				content: nav.extra[key]
			})
		}
	}

	store.commit('SET_HEAD', head)
	store.commit('SET_ACTIVE_NAV', nav.id)
}